import { Status } from '@enums';
import { OperatingHours, defaultOperatingHours } from '@types';

import { BaseModel } from './base.model';

export class Customer extends BaseModel {
  name: string = '';
  description: string = '';
  imageUrl: string = '';
  apiKey: string = '';
  status: Status = Status.APPROVED;
  operatingHours: OperatingHours = defaultOperatingHours;

  constructor(data?: Partial<Customer>) {
    super();
    Object.assign(this, data);
  }
}
